import { throttle, debounce, camelCase } from 'lodash';
//import StickySidebar from 'sticky-sidebar';
import StickySidebar from '../../libs/StickySidebar'; // isSidebarFitsViewport top & bottom spacing fix!!

import MatchHeight from '../../libs/MatchHeight';
import setupShareLinks from '../../libs/setupShareLinks';
// import BgData from '../../libs/BgData';

import Tags from './Tags';
import PageMenu from './PageMenu';
import NinjaForms from './NinjaForms';

class UiHelper
{
    static init()
    {

        // new BgData();
        // new MatchHeight();

        // handlers
        this.handlers = {
            resize: { throttle: [], debounce: [] },
            gmapsLoaded: [],
            fontsLoaded: []
        };

        // dom node references
        this.domNodes = { single: {}, multiple: {} };

        // init resize handler
        window.addEventListener('resize', throttle(e => this.handleResize(e, 'throttle'), 100));
        window.addEventListener('resize', debounce(e => this.handleResize(e, 'debounce'), 100));
        this.initHandleResize();

        // add primary nav resize handler
        this.setPrimaryNavWidth = this.setPrimaryNavWidth.bind(this);
        this.registerHandler('resize', this.setPrimaryNavWidth, 'throttle');

        // setup lazysizes
        window.lazySizesConfig = window.lazySizesConfig || {};
        window.lazySizesConfig.loadMode = 2;
        window.lazySizesConfig.expand = 200;

        // setup sticky sidebar
        this.stickySidebar();

        // share links
        setupShareLinks();

        // setup ninjaforms
        const nf = new NinjaForms();
        nf.init();

        this.registerHandler('fontsLoaded', () => { new MatchHeight(); });
        this.registerHandler('fontsLoaded', () => { Tags.init(); });
        this.registerHandler('fontsLoaded', () => { PageMenu.init(); });

        // google maps
        this.googleMapsReady = false;

        this.fixUnsupportedObjectFit();
    }

    static registerHandler(e, fn, type=false)
    {
        if (type) this.handlers[e][type].push(fn);
        else this.handlers[e].push(fn);
    }

    static initHandleResize()
    {
        this.setPrimaryNavWidth();
    }

    static handleResize(e=null, type)
    {
        this.handlers.resize[type].forEach(fn => fn(e));
    }

    static handleFontsLoaded()
    {
        this.handlers.fontsLoaded.forEach(fn => fn())
    }


    static setPrimaryNavWidth()
    {
        this.primaryNavWidth = this.getNode('.js-primary-nav').offsetWidth;
    }
    static getPrimaryNavWidth()
    {
        return this.primaryNavWidth;
    }

    static getNode(s, reset=false)
    {
        const ccs = this.camelCaseNodeSelector(s);
        if (!this.domNodes.single[ccs] || reset) this.domNodes.single[ccs] = document.querySelector(s);
        return this.domNodes.single[ccs];
    }
        static camelCaseNodeSelector(s)
        {
            return s[0] + camelCase(s);
        }

    static getNodes(s, reset=false)
    {
        const ccs = this.camelCaseNodeSelector(s);
        if (!this.domNodes.multiple[ccs] || reset) this.domNodes.multiple[ccs] = document.querySelectorAll(s);
        return this.domNodes.multiple[ccs];
    }

    static stickySidebar()
    {
        this.stickyEl = document.querySelector('.js-sticky');
        if (this.stickyEl)
        {
            this.stickySidebar = new StickySidebar(this.stickyEl, {
                topSpacing: window.innerWidth > 1199 ? 135 : 115,
                bottomSpacing: 30,
                containerSelector: '.js-sticky-container',
                innerWrapperSelector: '.js-sticky__inner',
                stickyClass: 'sticky--stuck',
                minWidth: 992
            });
            //hack hack :(
            setTimeout(() => { this.stickySidebar.updateSticky(); }, 1000)
        }
    }

    static fixUnsupportedObjectFit()
    {
        if (window.Modernizr.objectfit) return;

        Array.from(this.getNodes('.hero, .image-container--cover')).forEach(imageContainer => {
            const img = imageContainer.querySelector('img');
            if (img)
            {
                imageContainer.classList.add('bg-img-fallback');
                imageContainer.style.backgroundImage = `url('${img.dataset.src}')`;
            }
        });
    }

    static googleMapsApiHasLoaded()
    {
        this.handlers.gmapsLoaded.forEach(fn => fn());
    }

    static scrollTo(elementOrSelector)
    {
        const el = (typeof elementOrSelector === 'string') ? UiHelper.getNode(elementOrSelector) : elementOrSelector;

        const scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        const elY = el.getBoundingClientRect().top + scrollTop;
        window.scroll({ top: elY - 100, left: 0, behavior: 'smooth' });
    }
}

export default UiHelper;

// expose googleMapsApiLoaded to window
window.googleMapsApiHasLoaded = UiHelper.googleMapsApiHasLoaded.bind(UiHelper);
